import React from 'react';
import styles from './CodeBlock.module.css';

interface CodeBlockProps {
  color: string;
  children: React.ReactNode;
  indent?: number;
}

export const CodeBlock: React.FC<CodeBlockProps> = ({ color, children, indent = 0 }) => {
  return (
    <div className={styles.codeBlock} style={{ marginLeft: `${indent * 20}px`, backgroundColor: color }}>
      {children}
    </div>
  );
};
